import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import toasterNotification from '../common/toasterNotification';
import { login } from '../../services/authentication.service';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as GoogleLoginIcon } from '../../assets/images/google_login.svg';
import { Button } from 'react-bootstrap';

const GoogleLoginButton = (props) => {
  const navigate = useNavigate();
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => responseSuccessGoogle(tokenResponse),
  });

  const responseSuccessGoogle = async (res) => {
    try {
      const isUserExist = await login((props.data.email).toLowerCase(), props.data.password, props.data.remember, props.data.loginType, res.access_token);
      if (isUserExist) {
        if (props.searchParams && props.searchParams.get('verifyAdmin')) {
          navigate(`/verify-pharmacist/${props.searchParams.get('verifyAdmin')}`);
        } else{
          navigate('/orders');}
      }
    } catch(err) {
      toasterNotification(err, 'error', 'google-auth-failed');
    }
  };

  return (
    <div>
      <Button className="mt-3 w-100 bg-white align-item-center p-0 admin-login-wrapper" onClick={() => handleGoogleLogin()}>
        <div className='p-2 me-2 bg-white admin-login'>
          <GoogleLoginIcon />
        </div>
        <span style={{padding: '10px 10px 10px 0px', fontWeight: '500'}}>Admin Login</span>
      </Button>
    </div>
  );
};

export default GoogleLoginButton;
